import React from "react";
import { Component } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import {Helmet} from "react-helmet";

import Cookies from 'js-cookie';


import EditorModule from "./App/Item/Editor";
import Auth from "./App/Auth";
import Items from "./App/Items";
import Item from "./App/Item/Item";
import Photo from "./App/Item/Photo";
import Audio from "./App/Item/Audio";
import Video from "./App/Item/Video";
import Urls from "./App/Item/Urls";

import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';


class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: true
    };

    this.isAuth = this.isAuth.bind(this)
    this.logout = this.logout.bind(this)
    
  }

  componentDidMount(){
    this.isAuth()
  }

  isAuth() {
    let token = Cookies.get('session-acs');

    if (!token && window.location.pathname !== "/auth") {
      let uri = "/auth"
      if (window.location.pathname !== "/")
        uri += "?redirect=" + encodeURI(window.location.pathname)
      window.location.replace(uri)
    }

    if (!token && window.location.pathname === "/auth") {
      this.setState({
        loading: false
      })
    }

    if (token) {
      this.setState({
        loading: false
      })
    }
    
  }

  logout() {
    Cookies.remove('session-acs')
    window.location.replace("/auth")
  }

  render() {

    return (
      <>
        <header>
          <Helmet>
            <html lang="ru" />
            <meta charSet="utf-8"/>
            <link rel="icon" href="/favicon.ico"/>
            <meta name="viewport" content="width=device-width, initial-scale=1"/>
            <meta name="theme-color" content="#000000"/>
            <link rel="apple-touch-icon" href="/logo192.png"/>
            <link rel="manifest" href="/manifest.json" />
            <meta name="description" content="" />
            <title>Музей-квартира И.Д. Сытина — Панель управления выставкой</title>
          </Helmet>
        </header>
          {window.location.pathname !== "/auth" && (
            <Navbar className="mb-5" sticky="top" bg="dark" data-bs-theme="dark">
              <Container>
                <Navbar.Brand href="/" className="line-height-9">
                  <div>Панель управления</div>
                  <span className="small-extra">Музей-квартира И.Д. Сытина</span>
                </Navbar.Brand>
                  <Navbar.Toggle />
                  <Navbar.Collapse className="justify-content-end">
                    <Navbar.Text>
                      <a href="/auth" onClick={this.logout}>Выйти</a>
                    </Navbar.Text>
                </Navbar.Collapse>
              </Container>
            </Navbar>
          )}
          <Container className="container-main">
          {!this.state.loading && (
            <BrowserRouter>
              <Routes>
                <Route path="/auth" element={<Auth />} />
                <Route path="/" element={<Items />} />
                <Route path="/items/:id" element={<Item />}/>
                <Route path="/items/:id/editor" element={<EditorModule />}/>
                <Route path="/items/:id/photo" element={<Photo />}/>
                <Route path="/items/:id/audio" element={<Audio />}/>
                <Route path="/items/:id/video" element={<Video />}/>
                <Route path="/items/:id/urls" element={<Urls />}/>
              </Routes>
            </BrowserRouter>
          )}
        </Container>
      </>
    )

  }

}

export default App;